import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import { dinero } from "./posApi";

// Cuadrícula color × talla de un modelo.
//  modo "venta":   cada celda muestra la existencia; un toque agrega una pieza (se pueden tocar varias)
//  modo "entrada": cada celda es una casilla de cantidad y hay un solo costo para el modelo
// articulo: { _id, codigo, nombre, precioTienda, costoMX, colores:[{_id,name}], tallas:[{_id,name}], variantes:[{colores,tallas,existencia}] }
function VariantePicker({ articulo, modo = "venta", enCarrito = {}, onAgregar, onCerrar, conCosto = true, permiteSinExistencia = false }) {
  const [cant, setCant] = useState({});
  const [costo, setCosto] = useState("");
  const [tocados, setTocados] = useState({});

  useEffect(() => {
    setCant({}); setTocados({});
    setCosto(articulo && articulo.costoMX ? String(articulo.costoMX) : "");
  }, [articulo]);

  if (!articulo) return null;
  const k = (c, t) => `${c || ""}|${t || ""}`;
  const existencia = {};
  const codigoDe = {};
  (articulo.variantes || []).forEach((v) => { existencia[k(v.colores, v.tallas)] = v.existencia; codigoDe[k(v.colores, v.tallas)] = v.codigoBarras; });
  const colores = articulo.colores && articulo.colores.length ? articulo.colores : [{ _id: null, name: null }];
  const tallas = articulo.tallas && articulo.tallas.length ? articulo.tallas : [{ _id: null, name: null }];
  const sel = (c, t) => ({ colores: c._id, tallas: t._id, color: c.name, talla: t.name });

  const tocarVenta = (c, t) => {
    const key = k(c._id, t._id);
    const ya = enCarrito[key] || 0; // ya incluye lo que se va tocando
    if (ya >= (existencia[key] || 0) && !permiteSinExistencia) return; // con permiso, quien llama pide confirmación
    setTocados({ ...tocados, [key]: (tocados[key] || 0) + 1 });
    onAgregar([{ ...sel(c, t), cantidad: 1 }], false);
  };

  const totalEntrada = Object.values(cant).reduce((s, n) => s + (Number(n) || 0), 0);
  const agregarEntrada = () => {
    // En traspasos no se puede mandar más de lo que hay
    if (modo === "traspaso") {
      const excede = [];
      colores.forEach((c) => tallas.forEach((t) => {
        const n = parseInt(cant[k(c._id, t._id)], 10) || 0;
        if (n > (existencia[k(c._id, t._id)] || 0)) excede.push([c.name, t.name].filter(Boolean).join(" ") || articulo.codigo);
      }));
      if (excede.length) { window.alert(`No hay tantas piezas de: ${excede.join(", ")}`); return; }
    }
    const lista = [];
    colores.forEach((c) => tallas.forEach((t) => {
      const n = parseInt(cant[k(c._id, t._id)], 10);
      if (n > 0) lista.push({ ...sel(c, t), cantidad: n, costo: modo === "entrada" && conCosto && costo !== "" ? Number(costo) : "", codigoBarras: codigoDe[k(c._id, t._id)] });
    }));
    if (lista.length) onAgregar(lista, true);
  };

  const celda = { padding: 4, textAlign: "center", minWidth: 64 };
  return (
    <Modal isOpen={!!articulo} toggle={onCerrar} size="lg">
      <ModalHeader toggle={onCerrar}>
        {articulo.codigo} · {articulo.nombre}
        <div style={{ fontSize: "0.8rem", fontWeight: 400, color: "#64748b" }}>
          {modo === "venta" ? `${dinero(articulo.precioTienda)} · toca la talla y color que se lleva` : modo === "etiquetas" ? "¿Cuántas etiquetas de cada talla y color?" : modo === "traspaso" ? "¿Cuántas piezas de cada talla y color envías?" : "Captura cuántas piezas entran de cada talla y color"}
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="table-responsive">
          <table className="table table-sm table-bordered mb-0" style={{ fontSize: "0.85rem" }}>
            <thead>
              <tr>
                <th style={{ background: "#f8fafc" }}>{colores[0].name ? "Color / Talla" : ""}</th>
                {tallas.map((t) => <th key={t._id || "u"} style={{ ...celda, background: "#f8fafc" }}>{t.name || "Pieza"}</th>)}
              </tr>
            </thead>
            <tbody>
              {colores.map((c) => (
                <tr key={c._id || "u"}>
                  <th style={{ background: "#f8fafc", whiteSpace: "nowrap", verticalAlign: "middle" }}>{c.name || articulo.codigo}</th>
                  {tallas.map((t) => {
                    const key = k(c._id, t._id);
                    const ex = existencia[key] || 0;
                    if (modo !== "venta") {
                      return (
                        <td key={key} style={celda}>
                          <Input bsSize="sm" type="number" min="0" style={{ textAlign: "center" }} value={cant[key] || ""} placeholder={ex ? String(ex) : "0"} title={`Hay ${ex}`}
                            onChange={(e) => setCant({ ...cant, [key]: e.target.value })} />
                        </td>
                      );
                    }
                    const ya = enCarrito[key] || 0; // ya incluye lo que se va tocando
                    const libre = ex - ya;
                    return (
                      <td key={key} style={celda}>
                        <button type="button" onClick={() => tocarVenta(c, t)} disabled={libre <= 0 && !permiteSinExistencia}
                          title={libre <= 0 && permiteSinExistencia ? "Sin existencia en sistema: pide confirmación" : undefined}
                          style={{ width: "100%", border: libre > 0 ? "1px solid #10b981" : permiteSinExistencia ? "1px dashed #f59e0b" : "1px solid #e2e8f0", background: tocados[key] ? "#ecfdf5" : "#fff", borderRadius: 8, padding: "8px 4px", cursor: libre > 0 || permiteSinExistencia ? "pointer" : "not-allowed", opacity: libre > 0 ? 1 : permiteSinExistencia ? 0.75 : 0.4 }}>
                          <div style={{ fontWeight: 800, fontSize: "1rem", color: "#0f172a" }}>{ex}</div>
                          <div style={{ fontSize: "0.65rem", color: "#64748b" }}>{tocados[key] ? `+${tocados[key]} agregadas` : ya ? `${ya} en venta` : "disponibles"}</div>
                        </button>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {(modo === "etiquetas" || modo === "traspaso") && (
          <div className="mt-3" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            <Button size="sm" color="light" style={{ border: "1px solid #e2e8f0" }} onClick={() => {
              const n = {};
              (articulo.variantes || []).forEach((v) => { if (v.existencia > 0) n[k(v.colores, v.tallas)] = String(v.existencia); });
              setCant(n);
            }}>{modo === "traspaso" ? "Todo lo que hay" : "Una por cada pieza en existencia"}</Button>
            <span className="text-muted small">Los números grises son la existencia actual en la tienda.</span>
          </div>
        )}
        {modo === "entrada" && conCosto && (
          <div className="mt-3" style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div><label className="mb-0">Costo unitario</label><Input type="number" min="0" step="0.01" value={costo} onChange={(e) => setCosto(e.target.value)} style={{ width: 160 }} /></div>
            <div className="text-muted small">Los números grises son la existencia actual en la tienda.</div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        {modo !== "venta" ? (
          <>
            <Button color="secondary" onClick={onCerrar}>Cancelar</Button>
            <Button color="success" disabled={!totalEntrada} onClick={agregarEntrada}>Agregar {totalEntrada || ""} {modo === "etiquetas" ? "etiqueta(s)" : "pieza(s)"}</Button>
          </>
        ) : (
          <Button color="success" onClick={onCerrar}>Listo</Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default VariantePicker;
